<template>
  <!-- Page Heading -->
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.cra scheduled list") }}</h2>
    </div>
  </div>

  <div class="row g-3 mb-2">
    <div class="col-12 py-3">

      <!-- Search Filter Section (same as reference) -->
      <div class="ibox-content mb-1 px-3 py-2">
        <div class="form-group mb-1">
          <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">

            <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Visit Type</label>
              <select class="form-control" v-model="searchField.craVisitType">
            <option value="">Select</option>
            <option v-for="type in visitTypes" :key="type" :value="type">
              {{ type }}
            </option>
          </select>
            </div>

            <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Site Code</label>
               <select class="form-control" v-model="searchField.siteCode">
            <option value="">Select</option>
            <option v-for="site in sites" :key="site.siteID" :value="site.siteCode">
              {{ site.siteCode }}
            </option>
          </select>
            </div>

            <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Status</label>
             <select v-model="searchField.status" class="form-control">
              <option value="">Select</option>
            <option value="Planned">Planned</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Rescheduled">Rescheduled</option>
            <option value="Overdue">Overdue</option>
          </select>
            </div>

            <span
              class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end"
              @click="search()"
            >
              Search
            </span>

          </div>
        </div>
      </div>

      <!-- Schedule List Grid -->
      <div class="ibox-body">

        <!-- Header -->
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">Schedule List</h5>
        </div>

        <div class="ibox-content">

          <!-- Loading -->
          <div class="text-center" v-if="loadingCraSchedule">
            <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>

          <template v-else>
            <!-- Empty state -->
            <div class="text-center" v-if="!craScheduleList.length">
              {{ $t("navigations.no data available") }}
            </div>

            <!-- Table -->
            <div v-else class="table-responsive">
              <table class="table table-striped table-bordered dataTables">
                <thead>
                  <tr>
                    <th class="sort_block">
                      Visit Type
                    </th>
                    <th class="sort_block">
                      Monitoring Mode
                    </th>
                    <th class="sort_block">
                      Site Code
                    </th>
                    <th class="sort_block">
                      Planned Date
                    </th>
                    <th class="sort_block">
                      Actual Date
                    </th>
                    <th>
                      Reason
                    </th>
                    <th>
                      Status
                    </th>
                    <th class="text-center">
                      Tasks
                    </th>
                    <th class="text-center">
                      {{ $t("navigations.edit") }}
                    </th>
                    <th class="text-center">
                      {{ $t("navigations.delete") }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="item in craScheduleList"
                    :key="item.craScheduleId"
                  >
                    <td>{{ item.craVisitType }}</td>
                    <td>{{ item.monitoringMode }}</td>
                    <td>{{ item.siteCode }}</td>
                    <td>{{ formatdatetime(item.plannedDate) }}</td>
                    <td>{{ formatdatetime(item.actualDate) }}</td>
                    <td>{{ item.reason }}</td>
                    <td>{{ item.status }}</td>
                    <td class="text-center"><i
                        class="fa fa-eye editicon"
                       
                        @click="ViewTasks(item.craScheduleId)"
                      ></i></td>
                    <td class="text-center">
                      <i
                        class="fa fa-edit edit-delete"
                        style="color:#a13b7c"
                        @click="EditCra(item.craScheduleId)"
                      ></i>
                    </td>
                    <td class="text-center">
                      <i
                        class="fa fa-trash edit-delete"
                        style="color:#a13b7c"
                        @click="DeleteCra(item.craScheduleId)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="row mt-1 mx-0">
              <div class="col-lg-12 px-0">
                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                  <div class="d-flex justify-content-lg-end px-0">
                    <v-pagination
                      v-model="currentPage"
                      :pages="totalPages"
                      :range-size="1"
                      active-color="#618bd7"
                      @update:modelValue="loadPage"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>

  <CraModal
    v-if="showCraModel"
    :editingId="craScheduleId"
    @closeModal="closeCraModal"
    @saved="refreshCraList"
  />
</template>
<script src="./CraScheduleList.js"></script>